import { createContext, useContext } from 'react';

export const InteractiveTourContext = createContext<any>(null);

export const useInteractiveTourContext = () => {
  return useContext(InteractiveTourContext);
};
